
import { Options, Vue } from "vue-class-component";
import ChatHistory from "./ChatHistory.vue";
import MessageComposer from "./MessageComposer.vue";
import MoreMenu from "./MoreMenu.vue";
import Grid from "./Grid.vue";

@Options({
  components: {
    ChatHistory,
    MessageComposer,
    MoreMenu,
    Grid,
  },
  mounted() {
    if (window.innerHeight < 450) {
      this.lastScrollPosition = window.pageYOffset;
      window.addEventListener("scroll", this.onScroll);
    }
  },
  beforeDestroy() {
    if (window.innerHeight < 450) {
      window.removeEventListener("scroll", this.onScroll);
    }
  },
  data() {
    return {
      showHeader: true,
      lastScrollPosition: 0,
    };
  },
  methods: {
    onScroll() {
      if (window.pageYOffset < 0) {
        return;
      }
      if (Math.abs(window.pageYOffset - this.lastScrollPosition) < 40) {
        return;
      }
      this.showHeader = window.pageYOffset < this.lastScrollPosition;
      this.lastScrollPosition = window.pageYOffset;

      console.log(this.showHeader);
      console.log(this.lastScrollPosition);
    },
  },
})
export default class HomePage extends Vue {}
